// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"1a12ebf5","567":"b03ab3ee","651":"d34c4bd5"}[chunkId] + ".chunk.js";
};